class GLRaycastBuffer {
    constructor() {
        this._data = null;
        this._updateListeners = new Set();
    }

    get data() {
        return this._data;
    }

    listenUpdate(callback) {
        this._updateListeners.add(callback);
    }

    unlistenUpdate(callback) {
        this._updateListeners.delete(callback);
    }

    update(newData = undefined) {
        if (newData !== undefined) {
            this._data = newData;
        }

        for (const callback of this._updateListeners) {
            callback(this);
        }
    }
}

export default GLRaycastBuffer;
